export default {
	about: 'About us',
	mission: 'Mission',
	vision: 'Our Message',
	policy: 'Policy',
	qualityPolicy: 'Quality policy'
}